<section class="background-color-white">
    <div class="container" *ngIf="order$ | async as order">
        <h3 [innerHTML]="'booking.bookingParticipants.title' | translate"></h3>

        <div class="choice" *ngIf="showChoice$ | async as choice">
            <p class="large" [innerHTML]="'booking.bookingParticipants.groupBookingIntro' | translate"></p>
            <ul class="reset">
                <li>
                    <label for="goup" class="radiolabel">
                        <input type="radio" id="goup" name="drone" [value]="choice1" [checked]="choice1" (change)="choose1(true)" />
                        <span class="radiolabelvalue" [innerHTML]="'booking.bookingParticipants.radioGroupBooking' | translate"></span>
                    </label>
                </li>
                <li>
                    <label for="participants" class="radiolabel">
                        <input type="radio" id="participants" name="drone" [value]="choice2" [checked]="choice2" (change)="choose2(true)" />
                        <span class="radiolabelvalue" [innerHTML]="'booking.bookingParticipants.radioParticipants' | translate"></span>
                    </label>
                </li>
            </ul>
        </div>
        <div *ngIf="isGroupBooking$ | async" class="group-booking-wrapper">
            <h4 [innerHTML]="'booking.bookingParticipants.groupBookingTitle' | translate"></h4>
            <!-- <div *ngIf="order$ | async as order">
                <ng-container *ngIf="order.participants && order.participants.length <= 0">
                    <a
                        da-link
                        class="button secondary"
                        (click)="openPopupEmployees()"
                        [innerHTML]="'booking.bookingParticipants.addParticipantsToGroup' | translate"
                    ></a>
                </ng-container>
            </div> -->
            <div *ngIf="order$ | async as order">
                <ng-container *ngIf="order.participants.length <= 0">
                    <a
                        da-link
                        class="button secondary"
                        (click)="openPopupEmployees()"
                        [innerHTML]="'booking.bookingParticipants.addParticipantsToGroup' | translate"
                    ></a>
                </ng-container>
                <ng-container *ngIf="order.participants && order.participants.length > 0">
                    <div *ngIf="order.participants.length > 0" class="participants-info">
                        <span
                            ><span>{{ order.participants.length }}</span>
                            <span
                                *ngIf="order.participants.length === 1"
                                [innerHTML]="'booking.bookingParticipants.participant' | translate"
                            ></span
                            ><span
                                *ngIf="order.participants.length > 1"
                                [innerHTML]="'booking.bookingParticipants.participants' | translate"
                            ></span
                        ></span>
                        <a da-link class="" (click)="openPopupEmployees()" [innerHTML]="'booking.bookingParticipants.edit' | translate"></a>
                    </div>
                </ng-container>
                <da-participants-list [isBookingSummary]="false" [participants]="addedParticipants$ | async"></da-participants-list>
            </div>
        </div>
        <ng-container *ngIf="!(isGroupBooking$ | async)">
            <form [formGroup]="booking">
                <div formArrayName="persons" class="person-wrapper">
                    <div *ngFor="let person of booking.get('persons')['controls']; let i = index" [formGroupName]="i">
                        <div class="top">
                            <h4>
                                <span [innerHTML]="'booking.bookingSummary.participant' | translate"></span><span> {{ i + 1 }}</span>
                            </h4>
                            <a class="delete" (click)="removeParticipant(i)"
                                ><span *ngIf="i !== 0" class="drg-icon-delete"></span
                                ><span *ngIf="i !== 0" [innerHTML]="'booking.bookingSummary.remove' | translate" class="text"></span
                            ></a>
                            <div class="data-group full-width" *ngIf="i === 0">
                                <div class="group checkbox">
                                    <label class="checkboxlabel">
                                        <input
                                            type="checkbox"
                                            id="subscribe{{ i }}"
                                            formControlName="sameAs"
                                            (change)="sameAsPerson(i, $event.target.checked)"
                                        />
                                        <label
                                            for="subscribe{{ i }}"
                                            class="subscribe-me"
                                            [innerHTML]="'booking.bookingParticipants.sameAs' | translate"
                                        ></label>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <da-person-form
                            (inputChanged)="inputChanged($event)"
                            formControlName="person"
                            [index]="i"
                            [events]="eventsSubject.asObservable()"
                            [bookingForm]="booking"
                            [bookingPerson]="order.user"
                            [stepNum]="2"
                            (preselectCountryCode)="preselectCountry($event)"
                        ></da-person-form>
                    </div>
                </div>
            </form>
            <div class="error" *ngIf="showErrorMessage" [innerHTML]="'booking.bookingParticipants.error' | translate"></div>

            <div class="add-participant">
                <a
                    class="add"
                    *ngIf="!showErrorMessage"
                    (click)="addParticipant(true)"
                    [innerHTML]="'booking.bookingParticipants.add' | translate"
                ></a>
            </div>

            <span class="required" [innerHTML]="'booking.booking.required' | translate"></span>
        </ng-container>
        <div
            class="error"
            *ngIf="errorMessage$ | async"
            [innerHTML]="'booking.bookingParticipants.errorParticipantsNumber' | translate"
        ></div>
        <div class="button-wrapper">
            <a da-link class="button secondary" (click)="goToStep(1)" [innerHTML]="'booking.booking.back' | translate"></a>
            <a da-link class="button primary" (click)="goToStep(3)" [innerHTML]="'booking.booking.toTheSummary' | translate"></a>
        </div>
    </div>
</section>

<div class="notification" *ngIf="showTotalPriceMessage$ | async as showTotalPriceMessage">
    <div class="modal">
        <div class="location-popup" *ngIf="totalPrice$ | async as totalPrice" [ngClass]="totalPrice ? 'fade' : ''">
            <div class="title">
                <span [innerHTML]="'booking.booking.updateSuccess' | translate"></span>
            </div>
            <div class="inner-wrapper">
                <div class="details">
                    <span [innerHTML]="'booking.bookingParticipants.totalPrice' | translate"></span>
                    <span
                        ><span *ngIf="currencyPositionBefore$ | async" class="headline currency-before" [innerHTML]="currency"></span
                        >{{ totalPrice | currency: '':'':format:languageCode
                        }}<span *ngIf="!(currencyPositionBefore$ | async)" class="headline currency-after" [innerHTML]="currency"></span
                        ><span [innerHTML]="'booking.bookingParticipants.symbol' | translate"></span
                    ></span>
                </div>
                <a (click)="goToCart()" class="button secondary" [innerHTML]="'booking.bookingParticipants.showCart' | translate"></a>
            </div>
        </div>
    </div>
</div>

<ng-template #goupEmployees>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="group"></ng-container>
    </div>
</ng-template>
<ng-template #group>
    <div class="location-popup">
        <ng-container *ngIf="employees$ | async as employees">
            <da-checklist-employees [employees]="employees" (addedParticipants)="addedParticipants($event)"></da-checklist-employees>
        </ng-container>
    </div>
</ng-template>
